module.exports = __webpack_public_path__ + "img/auto_spin_btn.84a71883.png";